import angular from 'angular'
import './checklist_report.service'

angular
  .module('admin.checklist_report', ['admin.checklist_report.service'])
  .controller('ChecklistReportCtrl', ChecklistReportCtrl)

/** @ngInject */
function ChecklistReportCtrl(ChecklistReportService) {
  var vm = this
  vm.items = []
  vm.chaseStatus = [
    {
      id: 0,
      t: 'Unknown',
    },
    {
      id: 1,
      t: 'Active',
    },
    {
      id: 2,
      t: 'Chasing',
    },
    {
      id: 3,
      t: 'Skipped',
    },
    {
      id: 4,
      t: 'Archived',
    },
  ]
  vm.cs = null
  vm.comp = null
  vm.qua = null
  vm.view = null
  vm.cds = null
  vm.customDate = false
  vm.displayStartDate =
    moment()
      .startOf('day')
      .unix() + '000'
  vm.displayEndDate =
    moment()
      .startOf('day')
      .unix() + '000'
  vm.startDate =
    moment()
      .startOf('day')
      .unix() + '000000'
  vm.endDate =
    moment()
      .endOf('day')
      .unix() + '000000'
  vm.date1 = null
  vm.date2 = null

  vm.openCalendar = function(e, type) {
    e.preventDefault()
    e.stopPropagation()

    if (type === 1) {
      vm.isOpen = true
      vm.isOpen1 = false
    } else if (type === 2) {
      vm.isOpen = false
      vm.isOpen1 = true
    }
  }

  function reloadPagination() {
    vm.totalUsers = 0
    vm.oldPage = 0
    vm.perPage = 25
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  vm.filterDate = function(key) {
    vm.customDate = false
    switch (key) {
      case 'today':
        vm.startDate =
          moment()
            .startOf('day')
            .unix() + '000000'
        vm.endDate =
          moment()
            .endOf('day')
            .unix() + '000000'
        vm.displayStartDate =
          moment()
            .startOf('day')
            .unix() + '000'
        vm.displayEndDate =
          moment()
            .endOf('day')
            .unix() + '000'
        break
      case '7days':
        vm.startDate =
          moment()
            .subtract(7, 'days')
            .startOf('day')
            .unix() + '000000'
        vm.endDate =
          moment()
            .endOf('day')
            .unix() + '000000'
        vm.displayStartDate =
          moment()
            .subtract(7, 'days')
            .startOf('day')
            .unix() + '000'
        vm.displayEndDate =
          moment()
            .endOf('day')
            .unix() + '000'
        break
      case '15days':
        vm.startDate =
          moment()
            .subtract(15, 'days')
            .startOf('day')
            .unix() + '000000'
        vm.endDate =
          moment()
            .endOf('day')
            .unix() + '000000'
        vm.displayStartDate =
          moment()
            .subtract(15, 'days')
            .startOf('day')
            .unix() + '000'
        vm.displayEndDate =
          moment()
            .endOf('day')
            .unix() + '000'
        break
      case '30days':
        vm.startDate =
          moment()
            .subtract(30, 'days')
            .startOf('day')
            .unix() + '000000'
        vm.endDate =
          moment()
            .endOf('day')
            .unix() + '000000'
        vm.displayStartDate =
          moment()
            .subtract(30, 'days')
            .startOf('day')
            .unix() + '000'
        vm.displayEndDate =
          moment()
            .endOf('day')
            .unix() + '000'
        break
      default:
        vm.startDate =
          moment()
            .startOf('day')
            .unix() + '000000'
        vm.endDate =
          moment()
            .endOf('day')
            .unix() + '000000'
        vm.displayStartDate =
          moment()
            .startOf('day')
            .unix() + '000'
        vm.displayEndDate =
          moment()
            .endOf('day')
            .unix() + '000'
        break
    }
  }

  vm.selectCustomDate = function() {
    vm.customDate = !vm.customDate
    vm.startDate = null
    vm.endDate = null
    vm.displayStartDate = null
    vm.displayEndDate = null
  }

  reloadPagination()

  vm.load = function(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    var cs = !vm.cs ? '' : vm.cs
    var comp = !vm.comp ? '' : vm.comp
    var qua = !vm.qua ? '' : vm.qua
    var view = !vm.view ? '' : vm.view
    var cds = !vm.cds ? '' : vm.cds

    var selectValue = $('#checklistSelect').select2('val')
    if (selectValue) {
      cds = parseInt(selectValue)
    }

    if (vm.customDate) {
      if (!vm.date1 || !vm.date2) {
        swal('Must choose dates', '', 'error')
        return
      }

      vm.startDate = moment(vm.date1).unix() + '000000'
      vm.displayStartDate = moment(vm.date1).unix() + '000'
      vm.endDate = moment(vm.date2).unix() + '000000'
      vm.displayEndDate = moment(vm.date2).unix() + '000'
    }

    ChecklistReportService.list(
      vm.startDate,
      vm.endDate,
      cs,
      comp,
      qua,
      view,
      cds,
      vm.oldPage,
      25,
    ).then(function(result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        if (result.results[i]['st-chase'] === 0) {
          result.results[i].chase = 'Unknown'
        } else if (result.results[i]['st-chase'] === 1) {
          result.results[i].chase = 'Active'
        } else if (result.results[i]['st-chase'] === 2) {
          result.results[i].chase = 'Chasing'
        } else if (result.results[i]['st-chase'] === 3) {
          result.results[i].chase = 'Skipped'
        } else if (result.results[i]['st-chase'] === 4) {
          result.results[i].chase = 'Archived'
        }

        if (result.results[i].cd.st === 0) {
          result.results[i].cd.status = 'Draft'
        } else if (result.results[i].cd.st === 1) {
          result.results[i].cd.status = 'Published'
        } else if (result.results[i].cd.st === 2) {
          result.results[i].cd.status = 'Archived'
        }

        if (result.results[i]['ts-comp']) {
          result.results[i]['ts-comp'] = new Date(
            parseInt(
              result.results[i]['ts-comp']
                .toString()
                .substring(0, result.results[i]['ts-comp'].toString().length - 3),
            ),
          )
        }
        if (result.results[i].cd['ts-p']) {
          result.results[i].cd['ts-p'] = new Date(
            parseInt(
              result.results[i].cd['ts-p']
                .toString()
                .substring(0, result.results[i].cd['ts-p'].toString().length - 3),
            ),
          )
        }
        if (result.results[i].cd['ts-x']) {
          result.results[i].cd['ts-x'] = new Date(
            parseInt(
              result.results[i].cd['ts-x']
                .toString()
                .substring(0, result.results[i].cd['ts-x'].toString().length - 3),
            ),
          )
        }
      }
      vm.items = result.results
    })
  }

  vm.load()

  vm.pageChanged = function(newPage) {
    vm.load(newPage)
    window.scrollTo({ top: 180, behavior: 'smooth' })
  }

  vm.clear = function() {
    vm.cs = null
    vm.comp = null
    vm.qua = null
    vm.view = null
    vm.cds = null
    vm.displayStartDate =
      moment()
        .startOf('day')
        .unix() + '000'
    vm.displayEndDate =
      moment()
        .startOf('day')
        .unix() + '000'
    vm.startDate =
      moment()
        .startOf('day')
        .unix() + '000000'
    vm.endDate =
      moment()
        .endOf('day')
        .unix() + '000000'
    vm.date1 = null
    vm.date2 = null
    vm.customDate = false
    $('#checklistSelect').select2('val', '')
    reloadPagination()

    vm.load()
  }

  vm.search = function() {
    reloadPagination()
    vm.load()
  }

  vm.chaseOption = function(st) {
    if (st === 0) {
      return 'Unknown'
    } else if (st === 1) {
      return 'Active'
    } else if (st === 2) {
      return 'Chasing'
    } else if (st === 3) {
      return 'Skipped'
    } else if (st === 4) {
      return 'Archived'
    }
  }
}
